import { render, staticRenderFns } from "./AddAssetPoolDistribution.vue?vue&type=template&id=59cb2a5c&scoped=true"
import script from "./AddAssetPoolDistribution.vue?vue&type=script&lang=js"
export * from "./AddAssetPoolDistribution.vue?vue&type=script&lang=js"
import style0 from "./AddAssetPoolDistribution.vue?vue&type=style&index=0&id=59cb2a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb2a5c",
  null
  
)

export default component.exports